import type { ProjectSetupStatus } from '@/types/onboarding';

/** Collection completion belongs to the pipeline; workspace setup has its own lifecycle. */
export function resolveProjectSetupStatus(project: {
  setup_status?: ProjectSetupStatus | null;
  onboarding_completed?: boolean;
  onboarding_job_id?: string | null;
}): ProjectSetupStatus {
  if (
    project.setup_status === 'completed' ||
    project.setup_status === 'skipped' ||
    project.setup_status === 'in_progress'
  ) {
    return project.setup_status;
  }
  return project.onboarding_completed || project.onboarding_job_id ? 'completed' : 'in_progress';
}

export function isProjectWorkspaceReady(
  project: Parameters<typeof resolveProjectSetupStatus>[0]
): boolean {
  return resolveProjectSetupStatus(project) !== 'in_progress';
}

export function normalizeSetupWebsite(value: unknown): string {
  if (value === undefined || value === null || value === '') return '';
  if (typeof value !== 'string' || value.length > 2_000)
    throw new Error('Enter a valid website URL');
  const text = value.trim();
  if (!text) return '';
  let url: URL;
  try {
    url = new URL(/^[a-z][a-z0-9+.-]*:\/\//i.test(text) ? text : `https://${text}`);
  } catch {
    throw new Error('Enter a valid website URL');
  }
  if (
    !['http:', 'https:'].includes(url.protocol) ||
    !url.hostname ||
    url.username ||
    url.password
  ) {
    throw new Error('Enter a valid HTTP or HTTPS website URL');
  }
  return url.toString().replace(/\/$/, '');
}

export function normalizeSetupName(value: unknown): string {
  if (typeof value !== 'string' || !value.trim() || value.trim().length > 160) {
    throw new Error('Workspace name must contain 1–160 characters');
  }
  return value.trim();
}
